const CasesFilter = (textFilter, obj, item) => {
    if (!textFilter.trim()) {
        return obj
    } else if (item && item.toLowerCase().includes(textFilter.toLocaleLowerCase())) {
        return obj
    }
}

export { CasesFilter }